import { render, staticRenderFns } from "./ReceiptTable.vue?vue&type=template&id=19d1f72c&scoped=true"
import script from "./ReceiptTable.vue?vue&type=script&lang=js"
export * from "./ReceiptTable.vue?vue&type=script&lang=js"
import style0 from "./ReceiptTable.vue?vue&type=style&index=0&id=19d1f72c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1f72c",
  null
  
)

export default component.exports